// extracted by mini-css-extract-plugin
export var bodyFont = "index-module--body-font--a9bae";
export var disabled_feature = "index-module--disabled_feature--b3672";
export var feature = "index-module--feature--df5bb";
export var titleFont = "index-module--title-font--9efad";
export var wrapper = "index-module--wrapper--a7c50";